import React, {PureComponent} from "react"
import qs from "qs"
import {Redirect} from "react-router-dom"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import authentication from "@irati/auth"
import History from "@irati/utils/history"
import tracking from "@irati-tracking/wallet/tenantWallet"
import PaymentForm from "@irati-web/payments/src/components/PaymentForm"
import {getDomain} from "@irati/utils/links"
import endpoints from "@irati/payments/endpoints"
import {Topup} from "@irati/types"
import topupService from "@irati/wallet/services/TopUp"

import CardConfirmationPopUp from "./CardConfirmationPopUp"
import ErrorCard from "./ErrorCard"

interface Props extends InjectIntl {
  tenantWalletTopup: Topup
}

interface State {
  showCompletionModal: boolean
  isError: boolean
}

class CardPaymentFormV2 extends PureComponent<Props, State> {
  state: State = {
    showCompletionModal: false,
    isError: false
  }

  handleCardError = () => {
    this.setState({isError: true})
  }

  goBackToTransactions = () => {
    History.push({
      pathname: "/wallet/tenant"
    })
  }

  handleTryAgain = () => {
    const {tenantWalletTopup} = this.props
    History.push({
      pathname: "/wallet/tenant/top-up",
      tenantWalletTopup
    })
  }

  getPaymentRedirectUrl = () => {
    const {tenantWalletTopup} = this.props

    const domain = getDomain(authentication.userTenant().subdomain)
    const query = qs.stringify({
      redirectTo: `${domain}/wallet/tenant/top-up/confirm/${tenantWalletTopup.uuid}`
    })
    return `${endpoints.adyenRedirectCallbackUrl()}?${query}`
  }

  getTopupStatus = () => {
    return topupService
      .complete(this.props?.tenantWalletTopup?.uuid)
      .then(() => {
        tracking.completeTenantWalletTopUp()
        this.setState({showCompletionModal: true})
      })
      .catch(this.handleCardError)
  }

  render() {
    const {showCompletionModal, isError} = this.state
    const {tenantWalletTopup} = this.props

    if (!tenantWalletTopup) {
      return <Redirect to="wallet/tenant/top-up" />
    }

    if (isError) {
      return <ErrorCard goBackToTransactions={this.goBackToTransactions} handleTryAgain={this.handleTryAgain} />
    }

    if (showCompletionModal) {
      return (
        <CardConfirmationPopUp
          tenantWalletTopup={tenantWalletTopup}
          goBackToTransactions={this.goBackToTransactions}
          showCompletionModal={showCompletionModal}
        />
      )
    }

    return (
      <PaymentForm
        paymentOrder={tenantWalletTopup.paymentOrder}
        amount={tenantWalletTopup.amount}
        onComplete={this.getTopupStatus}
        redirectReturnUrl={this.getPaymentRedirectUrl()}
      />
    )
  }
}

export default injectIntl(CardPaymentFormV2)
